interface ChangedField {
  path: string
  value: unknown
  label: string
}

function parseIfJson(val: unknown): unknown {
  if (typeof val === "string") {
    try {
      return JSON.parse(val)
    } catch {
      return val
    }
  }
  return val
}

export function getChangedFields(
  baseValue: unknown,
  overrideValue: unknown,
  fieldKey: string,
): ChangedField[] {
  const changes: ChangedField[] = []

  const base = parseIfJson(baseValue)
  const override = parseIfJson(overrideValue)

  if (
    base &&
    override &&
    typeof base === "object" &&
    typeof override === "object" &&
    !Array.isArray(base) &&
    !Array.isArray(override)
  ) {
    const diffObjects = (
      baseObj: Record<string, unknown>,
      overrideObj: Record<string, unknown>,
      path: string[] = [],
    ) => {
      for (const key of Object.keys(overrideObj)) {
        const baseProp = baseObj[key]
        const overrideProp = overrideObj[key]
        const currentPath = [...path, key]

        if (
          baseProp &&
          overrideProp &&
          typeof baseProp === "object" &&
          typeof overrideProp === "object" &&
          !Array.isArray(baseProp) &&
          !Array.isArray(overrideProp)
        ) {
          diffObjects(
            baseProp as Record<string, unknown>,
            overrideProp as Record<string, unknown>,
            currentPath,
          )
        } else if (JSON.stringify(baseProp) !== JSON.stringify(overrideProp)) {
          const lastKey = currentPath[currentPath.length - 1]
          const isStructuredValue =
            overrideProp !== null && typeof overrideProp === "object"
          const displayValue =
            typeof overrideProp === "string" ||
            typeof overrideProp === "number" ||
            typeof overrideProp === "boolean"
              ? String(overrideProp)
              : JSON.stringify(overrideProp)

          changes.push({
            path: currentPath.join("."),
            value: overrideProp,
            label: isStructuredValue ? lastKey : `${lastKey}: ${displayValue}`,
          })
        }
      }
    }

    diffObjects(
      base as Record<string, unknown>,
      override as Record<string, unknown>,
    )
  }

  if (changes.length === 0) {
    changes.push({
      path: fieldKey,
      value: override,
      label: fieldKey,
    })
  }

  return changes
}

export function getAllChangedFields(
  configOverrides: Record<string, unknown>,
  baseMetadata: Record<string, unknown>,
): ChangedField[] {
  const allChanges: ChangedField[] = []

  for (const [key, overrideValue] of Object.entries(configOverrides)) {
    const baseValue = baseMetadata[key]
    const changes = getChangedFields(baseValue, overrideValue, key)
    allChanges.push(...changes)
  }

  return allChanges
}
